import type {AppThunk} from '../../../actions/types'
import type {LoadedEndpoints} from '../../../routes/loadEndpoint'
import {loadEndpoint} from '../../../routes/loadEndpoint'
import {getExtensionEndpointsByKind} from '../../../selectors'
import {buildArtifactsApi} from '../../../services/buildArtifacts'
import type {BuildId} from '../../../types'

import {preloadFileTreeNodeExtension} from './FileTreeNode/FileTreeNodeExtension/FileTreeNodeExtension.preload'

export const preloadBuildArtifactsTree =
  (buildId: BuildId, showAll = false): AppThunk<LoadedEndpoints> =>
  (dispatch, getState) => [
    dispatch(loadEndpoint(buildArtifactsApi.endpoints.getArtifactsSize, {buildId, showAll})),
    ...getExtensionEndpointsByKind(getState(), 'artifacts').flatMap(({endpoint}) =>
      dispatch(preloadFileTreeNodeExtension({endpoint, buildId})),
    ),
  ]
